<i18n>
{
  "fr": {
    "configuratorLayerEditorModalToolbarColorPickerItem": {
      "label": "Sélectionner une couleur",
      "title": "@:configuratorLayerEditorModalToolbarColorPickerItem.label"
    }
  }
}
</i18n>

<template>
  <BaseDropdown
    v-model="isExpanded"
    class="configurator-layer-editor-modal-toolbar-color-picker-item"
    v-bind="{
      modalBreakpoint: Breakpoint.CONFIGURATOR_XS,
      modalTargetSlot: 'container',
      modalClass:
        'configurator-layer-editor-modal-toolbar-color-picker-item__modal',
      dropdownTargetClass:
        'configurator-layer-editor-modal-toolbar-color-picker-item__target-wrapper',
      portalDestination: '#portal-container--footer',
    }"
  >
    <template #trigger="{ toggleState }">
      <button
        type="button"
        :title="$t('configuratorLayerEditorModalToolbarColorPickerItem.title')"
        class="configurator-layer-editor-modal-toolbar-color-picker-item__trigger"
        @click="toggleState"
      >
        <ConfiguratorColoredDot
          v-if="localColor"
          class="configurator-layer-editor-modal-toolbar-color-picker-item__trigger-preview"
          tag="span"
          :color="localColor"
        />

        <span
          class="configurator-layer-editor-modal-toolbar-color-picker-item__trigger-label"
          v-text="
            $t('configuratorLayerEditorModalToolbarColorPickerItem.label')
          "
        ></span>
      </button>
    </template>

    <template #target>
      <ChromePicker :value="localColor" disable-alpha @input="updateColor" />
    </template>
  </BaseDropdown>
</template>

<script>
import BaseDropdown from '../../../BaseDropdown';
import ConfiguratorColoredDot from '../../ConfiguratorColoredDot';
import { Chrome } from 'vue-color';
import { Breakpoint } from '../../../../utils/breakpoints';

export default {
  name: 'ConfiguratorLayerEditorModalToolbarColorPickerItem',
  components: { ConfiguratorColoredDot, BaseDropdown, ChromePicker: Chrome },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: '#000',
    },
  },
  data() {
    return {
      Breakpoint,
      localColor: undefined,
      isExpanded: false,
    };
  },
  watch: {
    value: {
      handler(color) {
        this.localColor = color;
      },
      immediate: true,
    },
  },
  methods: {
    updateColor({ hex }) {
      this.localColor = hex;

      this.$emit('change', this.localColor);
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-layer-editor-modal-toolbar-color-picker-item {
  &__trigger {
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 0;
    font: inherit;
    background: none;
    padding: 0.5em;
    margin: 0;

    &::after {
      @extend %icon;
      @extend %icon--arrow-fill-bottom;
      font-size: 0.5em;
      display: block;
      margin-left: 1em;
    }
  }

  &__trigger-preview {
    display: inline-block;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    font-size: 1.5em;
  }

  &__trigger-label {
    @include sr-only();
  }
}
</style>

<style lang="scss">
.configurator-layer-editor-modal-toolbar-color-picker-item {
  &__target-wrapper {
    // TODO Do stuff here
    z-index: 1000;
  }

  &__modal {
    .base-modal__body {
      background-color: $color-white;
    }

    .vc-chrome {
      width: auto;
    }
  }
}
</style>
